import { defineComponent as _defineComponent } from 'vue'
import type { DefineComponent } from 'vue';
import { computed, ref, toRefs } from '@nuxtjs/composition-api';
import type { Props as IconProps } from '~/core/components/base/image/SvgThemedIcon.vue';
import type { Unit } from '~/core/types/affility/components/countdown/Unit';
import type { SlotPropsTransform } from '~/core/types/affility/components/countdown/SlotPropsTransform';
import type { Now } from '~/core/types/affility/components/countdown/Now';

interface Props {
    theme?: 'light' | 'dark',
    time: string | number | Date,
    units?: Unit[],
    size?: 'l' | 'm',
    closeTime?: number,
    autoStart?: boolean,
    emitEvents?: boolean,
    interval?: number,
    now?: Now,
    transform?: SlotPropsTransform,
    clickable?: boolean,
    title?: string,
    countdownTag?: string | DefineComponent,
    tag?: string | DefineComponent,
    clickableIcon?: IconProps,
    redOnAborted?: boolean,
    redOnStopped?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InCard',
  props: {
    theme: null,
    time: null,
    units: null,
    size: { default: 'm' },
    closeTime: null,
    autoStart: { type: Boolean, default: true },
    emitEvents: { type: Boolean, default: true },
    interval: null,
    now: null,
    transform: null,
    clickable: { type: Boolean, default: false },
    title: null,
    countdownTag: null,
    tag: { default: 'div' },
    clickableIcon: { default: () => ({
        name: 'more-right',
        path: 'arrows',
        color: 'neutral-icons-shade-50-70',
    }) },
    redOnAborted: { type: Boolean },
    redOnStopped: { type: Boolean }
  },
  emits: ['start', 'end', 'progress', 'abort'],
  setup(__props: any) {

const props = __props as { theme?: 'light' | 'dark', time: string | number | Date, units?: Unit[], size: 'l' | 'm', closeTime?: number, autoStart: boolean, emitEvents: boolean, interval?: number, now?: Now, transform?: SlotPropsTransform, clickable: boolean, title?: string, countdownTag?: string | DefineComponent, tag: string | DefineComponent, clickableIcon: IconProps, redOnAborted?: boolean, redOnStopped?: boolean };





const {
    theme,
    time,
    units,
    size,
    closeTime,
    tag,
    autoStart,
    emitEvents,
    interval,
    now,
    transform,
    clickable,
    title,
    countdownTag,
    clickableIcon,
    redOnAborted,
    redOnStopped,
} = toRefs(props);

const isInProgress = ref(false);
const isAborted = ref(false);

const clickableIconSize = computed(() => clickableIcon.value.size || (size.value === 'l' ? 'm' : 's'));

return { __sfc: true,props, theme, time, units, size, closeTime, tag, autoStart, emitEvents, interval, now, transform, clickable, title, countdownTag, clickableIcon, redOnAborted, redOnStopped, isInProgress, isAborted, clickableIconSize }
}

})